<template>
  <div class="d-flex flex-column align-center justify-center">
    <div v-if="status == 'pending'" class="d-flex flex-column align-center justify-center">
      <div>
        <div class="text-h6 text-uppercase">Ouverture des inscriptions dans</div>
      </div>
      <div class="d-flex flex-start sm-gap">
        <v-card v-if="countdown.months && countdown.months > 0"
          class="d-flex flex-column align-center px-2 py-1 rounded bg-grey_3 bordered" elevation="0">
          <div class="font-weight-bold text-dark-red" style="font-size: 1.3rem">{{ countdown.months }}</div>
          <div>mois</div>
        </v-card>
        <v-card class="d-flex flex-column align-center px-2 py-1 rounded bg-grey_3 bordered" elevation="0">
          <div class="font-weight-bold text-dark-red" style="font-size: 1.3rem">{{ countdown.days }}</div>
          <div>jour<span v-if="countdown.days > 1">s</span></div>
        </v-card>
        <v-card class="d-flex flex-column align-center px-2 py-1 rounded bg-grey_3 bordered" elevation="0">
          <div class="font-weight-bold text-dark-red" style="font-size: 1.3rem">{{ countdown.hours }}</div>
          <div>heure<span v-if="countdown.hours > 1">s</span></div>
        </v-card>
        <v-card class="d-flex flex-column align-center px-2 py-1 rounded bg-grey_3 bordered" elevation="0">
          <div class="font-weight-bold text-dark-red" style="font-size: 1.3rem">{{ countdown.minutes }}</div>
          <div class="">min<span v-if="countdown.minutes > 1">s</span></div>
        </v-card>
        <v-card class="d-flex flex-column align-center px-2 py-1 rounded bg-grey_3 bordered" elevation="0">
          <div class="font-weight-bold text-dark-red" style="font-size: 1.3rem">{{ countdown.seconds }}</div>
          <div>sec<span v-if="countdown.seconds > 1">s</span></div>
        </v-card>
      </div>
    </div>
    <div v-else>
      <div class="d-flex flex-column align-center justify-center">
        <div class="text-h6 text-uppercase">Ouverture en cours, cette page va automatiquement s'actualiser</div>
        <!-- spinner -->
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ["date", "heure"],
  data() {
    return {
      defer: Math.floor(Math.random() * 15),
      status: "pending",
      countdown: {
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      targetDate: this.$moment(this.date + " " + this.heure),
    };
  },

  methods: {
    // Calculate the countdown
    calculateCountdown() {
      const now = this.$moment();
      let target = this.$moment(this.targetDate);
      // add random seconds to defer the reload, 0 to 20 seconds
      if (this.status == 'done') {
        target.add(this.defer, 'seconds');
      }
      const duration = this.$moment.duration(target.diff(now));

      if (parseInt(duration.seconds()) < 0) {
        if (this.status == 'done') {

          window.location.reload();
        }
        else {
          this.countdown.seconds = 0;
          this.status = "done";
        }



      }
      this.countdown.months = this.formatValue(duration.months());
      this.countdown.days = this.formatValue(duration.days());
      this.countdown.hours = this.formatValue(duration.hours());
      this.countdown.minutes = this.formatValue(duration.minutes());
      this.countdown.seconds = this.formatValue(duration.seconds());
    },
    formatValue(value) {
      if (value < 0) {
        return "00";
      }
      return value < 10 ? "0" + value : value;
    },
  },
  mounted() {
    this.calculateCountdown();
    // Update the countdown every second
    setInterval(() => {
      this.calculateCountdown();
    }, 1000);
  },
};
</script>

<style lang="scss" scoped></style>